var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoading)?_c('prd-loader'):_c('purchases-create-or-edit-product')}
var staticRenderFns = []

export { render, staticRenderFns }